import React from 'react';
import _ from 'lodash';

export default class ProductCard extends React.Component {
  renderPrice(priceString) {
    return (
      <span>
        <sup className="sup-text">$</sup>{_.trim(priceString, '$')}
      </span>
    );
  }

  render() {
    const { product } = this.props;
    return (
      <div className="ui raised card width-100">
        <div className="content center-aligned light-smoke-bg">
          <img className="ui image" src={require(`../../assets/${product.image}`)} />
          <p className="no-top italic-text">{product.title}</p>
        </div>
        <div className="content center-aligned">
          <div className="description thick-text">
            <h1 className="big-text t-w-h-5 no-bottom">{this.renderPrice(product.price)}</h1>
            {product.meta}
          </div>
        </div>
        <div className="extra content center-aligned">
          <p className="no-top thick-text">{product.extraTitle}&nbsp;&nbsp;{this.renderPrice(product.extraDescription)}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ProductCard/index.jsx